import { FC } from "react"
import {
  Alert,
  Box,
  IconButton,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material"
import { DeleteOutline, EditOutlined } from "@mui/icons-material"
import { getApiErrorMessage } from "@/core/utils"
import { StaffSchedule } from "../../interfaces"
import { normalizeHex, readableTextColor } from "../../model/shiftTypeColor"

interface ShiftTypesTableProps {
  shiftTypes?: StaffSchedule.ShiftType[]
  isLoading: boolean
  error?: unknown
  canWrite: boolean
  onEdit: (shiftType: StaffSchedule.ShiftType) => void
  onDelete: (shiftType: StaffSchedule.ShiftType) => void
}

export const ShiftTypesTable: FC<ShiftTypesTableProps> = ({
  shiftTypes,
  isLoading,
  error,
  canWrite,
  onEdit,
  onDelete,
}) => {
  if (error) {
    return <Alert severity="error">{getApiErrorMessage(error)}</Alert>
  }
  return (
    <Table size="small" sx={{ maxWidth: 720 }}>
      <TableHead>
        <TableRow>
          <TableCell>Ячейка</TableCell>
          <TableCell>Название</TableCell>
          {canWrite && <TableCell align="right">Действия</TableCell>}
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading
          ? Array.from({ length: 4 }, (_, i) => (
              <TableRow key={i}>
                <TableCell colSpan={3}>
                  <Skeleton />
                </TableCell>
              </TableRow>
            ))
          : (shiftTypes ?? []).map((t) => (
              <TableRow key={t.id}>
                <TableCell>
                  {/* Превью ровно такое же, как ячейка грида: цвет из данных, текст — контрастный */}
                  <Box
                    style={{
                      backgroundColor: normalizeHex(t.color),
                      color: readableTextColor(t.color),
                    }}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                      px: 1,
                      py: 0.25,
                      borderRadius: 0.5,
                      fontSize: 16,
                    }}
                  >
                    {t.emoji} {t.short_name}
                  </Box>
                </TableCell>
                <TableCell>{t.name}</TableCell>
                {canWrite && (
                  <TableCell align="right">
                    <IconButton
                      size="small"
                      onClick={() => onEdit(t)}
                      aria-label="Редактировать"
                    >
                      <EditOutlined fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => onDelete(t)}
                      aria-label="Удалить"
                    >
                      <DeleteOutline fontSize="small" />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
      </TableBody>
    </Table>
  )
}
